export const ONE_HOUR = 1;
export const ONE_DAY = 1;
export const DEFAULT_DIFFERENCE_BETWEEN_DATES_IN_HOURS = 8;
